// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__i0O-K","error":"Textarea_error__3oneZ","readonly":"Textarea_readonly__2TtzA","disabled":"Textarea_disabled__1Eie5"};